import { app } from '../app';

class StatisticsResource {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    getUserOtpStatistics() {
        const url = `app/rest/statistics`;
        return this.$http.get(url).then(({data}) => data);
    }

    getCompanyAdminAudits(companyId, role) {
        const url = `app/rest/company/${companyId}/statistics/role/${role}`;
        return this.$http.get(url).then(({data}) => data);
    }
}

app.service('StatisticsResource', StatisticsResource);



// WEBPACK FOOTER //
// ./src/portal/rest/StatisticsResource.js